import {
  fork,
  put,
  take,
  takeLatest,
  call,
  select,
  delay,
} from 'redux-saga/effects';
import { FRAME_APP_MOUNTED } from '../../../actions/frameActions';
import {
  getCustomerInsuredPopUpFlag,
  getCustomerECommEligibleFlag,
} from '../../../selectors/userSelectors';
import {
  getModals,
  getJourneyNameByModal,
} from '../../emma-modal/selectors/selector';
import { getHaveReadNewFeatures } from '../../../selectors/sideBarItemSelectors';
import HomePagePopUpRegistry from '../../../registries/HomePagePopUpRegistry';
import _ from 'lodash';
import {
  INSURED_SHARE,
  INSURED_COPY,
  INSURED_REQUEST_ACCESS,
  INSURED_COPY_REQUEST_ACCESS,
  POPUP_NOT_SHOW_AGAIN,
  AXA_GOAL_INSURED_SHARE,
  AXA_GOAL_INSURED_COPY,
} from '../actions/modalAction';
import { pushHaveReadNewFeatureSingle } from '../../../actions/sideBarItemActions';
import { showModal } from '../../emma-modal/actions/index';
import { getShare } from '../../emma-common/selectors/ehubSelector';
import { objectFormat } from '../../../utils/WebUtils';
import { getLanguage } from '../../../selectors/userSelectors';

const PROFILE_UPDATE_REMINDER_POPUP = 'profileUpdateReminderPopup';
const EREGISTRATION_HOME_POPUP = 'eRegistrationHomePopup';
const INSURED_LOGIN_INVITATION = 'insuredLoginInvitation';

function* waitUntilReadStateIsReady() {
  let haveReadNewFeature = yield select(getHaveReadNewFeatures);
  while (haveReadNewFeature === undefined) {
    yield delay(1000);
    haveReadNewFeature = yield select(getHaveReadNewFeatures);
  }
}

function* fetchInsuredModalComplete(action: any) {
  const { payload } = action;
  const journeyName = yield select(
    getJourneyNameByModal,
    INSURED_LOGIN_INVITATION,
  );

  if (!journeyName) return;

  // make sure isShowRedDot has been fetched
  yield call(waitUntilReadStateIsReady);

  const isInsured = payload && payload.isInsured;
  const isShowModal = yield isShowRedDot(journeyName);

  if (isInsured && isShowModal) {
    HomePagePopUpRegistry.setFetchDataCompleted(journeyName, true);
  } else {
    HomePagePopUpRegistry.setIsShowPopupCompleted(journeyName);
    HomePagePopUpRegistry.setFetchDataCompleted(journeyName);
  }
}

function* fetchERegistrationHomeModalComplete(action: any) {
  const { payload } = action;
  const journeyName = yield select(
    getJourneyNameByModal,
    EREGISTRATION_HOME_POPUP,
  );

  if (!journeyName) return;

  // make sure isShowRedDot has been fetched
  yield call(waitUntilReadStateIsReady);

  const isEligible = payload && payload.isEligible;
  const isShowModal = yield isShowRedDot(journeyName);

  if (isEligible && isShowModal) {
    HomePagePopUpRegistry.setFetchDataCompleted(journeyName, true);
  } else {
    HomePagePopUpRegistry.setIsShowPopupCompleted(journeyName);
    HomePagePopUpRegistry.setFetchDataCompleted(journeyName);
  }
}

export function* isShowRedDot(targetFeature: string) {
  let features = yield select(getHaveReadNewFeatures);

  if (features.features) {
    if (features.features.length == 0) {
      return true;
    }
    features = features.features;

    const featureFound = features.some(
      (feature: any) => feature.id === targetFeature,
    );
    const featureCountNotMax = features.some((feature: any) =>
      isMaxCountReached(feature, targetFeature),
    );
    return Array.isArray(features) && (!featureFound || featureCountNotMax);
  }
  return false;
}

function* getCurrentClickCount(targetFeature: string) {
  let features = yield select(getHaveReadNewFeatures);

  if (features.features) {
    if (features.features.length == 0) {
      return 0;
    }
    features = features.features;

    const featureFound = features.find(
      (feature: any) => feature.id === targetFeature,
    );
    return featureFound ? featureFound.clickCount : 0;
  }
  return 0;
}

function isMaxCountReached(feature: any, targetFeature: string) {
  const maxCount = getMaxCount(targetFeature);
  return feature.clickCount < maxCount && feature.id === targetFeature;
}

function getMaxCount(targetFeature: string) {
  return 1;
}

function* insuredShare(action: any) {
  console.log(action);
  const modals = yield select(getModals);
  if (modals && modals.webShare) {
    yield put(showModal(modals.webShare.query));
  }
}

function* insuredCopy(action: any) {
  console.log(action);
  const modals = yield select(getShare, 'insuredInvitation');
  if (modals && modals.query && navigator) {
    const language = yield select(getLanguage);
    const query = objectFormat(modals.query, language);
    if (navigator.clipboard && query.message) {
      navigator.clipboard.writeText(query.message).then(() => {
        console.log('copy success');
      });
    }
  }
}

const AXA_GOAL_MODAL_NAME = 'axaGoalInsuredInvitation';
function* axaGoalInsuredShare(action: any) {
  const modals = yield select(getModals);
  if (modals && modals[AXA_GOAL_MODAL_NAME]) {
    yield put(showModal(modals[AXA_GOAL_MODAL_NAME].query));
  }
}
function* axaGoalInsuredShareCopy(action: any) {
  const modals = yield select(getShare, AXA_GOAL_MODAL_NAME);
  if (modals && modals.query && navigator) {
    const language = yield select(getLanguage);
    const query = objectFormat(modals.query, language);
    if (navigator.clipboard && query.message) {
      navigator.clipboard.writeText(query.message).then(() => {
        console.log('copy success');
      });
    }
  }
}

function* insuredRequestAccess(action: any) {
  console.log(action);
  const modals = yield select(getModals);
  if (modals && modals.requestAccess) {
    yield put(showModal(modals.requestAccess.query));
  }
}

function* insuredCopyRequestAccess(action: any) {
  console.log(action);
  const modals = yield select(getShare, 'insuredRequestAccess');
  if (modals && modals.query && navigator) {
    const language = yield select(getLanguage);
    const query = objectFormat(modals.query, language);
    if (navigator.clipboard && query.message) {
      navigator.clipboard.writeText(query.message).then(() => {
        console.log('copy success');
      });
    }
  }
}

function* popupNotShowAgain(action: any) {
  const journeyName = action.payload && action.payload.journeyName;

  if (journeyName) {
    const clickCount = yield call(getCurrentClickCount, journeyName);
    yield put(pushHaveReadNewFeatureSingle(journeyName, clickCount + 1, 4));
  }
}

function* readInsuredModal(): any {
  const insuredPopUpFlag = yield select(getCustomerInsuredPopUpFlag);
  yield call(fetchInsuredModalComplete, {
    payload: { isInsured: insuredPopUpFlag === 'Y' },
  });
}

function* readERegistrationHomeModal(): any {
  const eCommEligibleFlag = yield select(getCustomerECommEligibleFlag);
  yield call(fetchERegistrationHomeModalComplete, {
    payload: { isEligible: eCommEligibleFlag === 'Y' },
  });
}

function* modalSaga(): any {
  yield takeLatest(FRAME_APP_MOUNTED, readInsuredModal);
  yield takeLatest(FRAME_APP_MOUNTED, readERegistrationHomeModal);
  yield takeLatest(INSURED_SHARE, insuredShare);
  yield takeLatest(AXA_GOAL_INSURED_SHARE, axaGoalInsuredShare);
  yield takeLatest(INSURED_COPY, insuredCopy);
  yield takeLatest(AXA_GOAL_INSURED_COPY, axaGoalInsuredShareCopy);
  yield takeLatest(INSURED_REQUEST_ACCESS, insuredRequestAccess);
  yield takeLatest(INSURED_COPY_REQUEST_ACCESS, insuredCopyRequestAccess);

  yield takeLatest(POPUP_NOT_SHOW_AGAIN, popupNotShowAgain);
}

export default modalSaga;
